import { findArray } from 'helpers/utils'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const OwsRaceInfo = ({ config }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let laps = findArray(config.extendedConfig, { code: ['LAPS_NUM'] })?.value
    let intermediate = findArray(config.extendedConfig, { code: ['INTERMEDIATES_NUM'] })?.value
    return (
        <>
            <div>
                <b><Label data="LabelNumLap" />:</b> {laps}.&emsp;
                <b><Label data="LabelIntermediate" sport={mirs_discipline} />:</b> {intermediate}.
            </div>
        </>
    )
};
export default OwsRaceInfo;